<template lang="pug">
  section.digitalpaper
    .col
      h2 Revisa nuestro <br> papel digital<br><strong>aquí</strong>
    .col
      .papel-wrapper
        a(href="http://edition.pagesuite.com/html5/reader/production/default.aspx?pubname=&pubid=1ccad72c-86f1-4ed8-b7ce-d1c7fc20e55a", title="Leer Papel Digital")
          span.shadow
          img.img-fluid(src="http://edition.pagesuite-professional.co.uk/get_image.aspx?w=300&pbid=1ccad72c-86f1-4ed8-b7ce-d1c7fc20e55a", alt="Leer Papel Digital")
</template>

<script lang="js">
  export default  {
    name: 'header-digital-paper',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="postcss">
  .digitalpaper {
    display: grid;
    grid-template-columns: repeat(2, 50%);
    grid-template-rows: 60px;
    grid-gap: 0.5rem;
    // overflow: hidden;
    > .col{
      position: relative;
    }
    .papel-wrapper{
      padding: 2px 10px 0 0;
      position: absolute;
      transition: all .5s cubic-bezier(.86,.03,.12,.99);
      left: 0;
      right: 0;
      top: 0;
      overflow: hidden;
      max-height: 100%;
    }
    &:hover{
      .papel-wrapper{
        padding-bottom: 260px;
      }
    }
    h2{
      text-align: right;
      text-transform: uppercase;
      font-size: 16px;
      font-family: 'Open Sans', sans-serif;
      font-weight: 300;
      color: rgba(0,0,0,0.5);
      line-height: 18px;
      strong{
        font-weight: 700;
        color: black;
      }
    }
    a{
      display: inline-block;
      width: auto;
      position: relative;
      z-index: 3;
      &:after,
      &:before{
        background-color: white;
        box-shadow: 4px 0px 6px rgba(0,0,0,0.2);
        content: '';
        position: absolute;
        width: 100%;
      }
      &:after{
        left: 3px;
        top: 4px;
        bottom: 4px;
      }
      &:before{
        left: 7px;
        top: 8px;
        bottom: 8px;
      }
      img{
        display: block;
        position: relative;
        z-index: 2;
        box-shadow: 4px 0px 6px rgba(0,0,0,0.2);
        max-width: 100%;
      }
      .shadow{
        display: block;
        background: linear-gradient(88deg, rgba(0,0,0,0.8), rgba(255,255,255,.4) 15%, transparent 40%);
        mix-blend-mode: hard-light;
        content: '';
        position: absolute;
        z-index: 3;
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
